import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container" style={{
        background: "linear-gradient(135deg, rgba(0, 0, 0, 0.65), rgba(0, 0, 0, 0.75)), url('https://images.unsplash.com/photo-1641128324972-af3212f0f6bd?q=80') no-repeat center center fixed",
        backgroundSize: "cover",
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        position: "relative",
      }}>
      <div className="not-found-content">
        <div className="logo-container animate__animated animate__fadeInDown">
          <img src="/assets/logo-1.png" alt="Logo" className="img-fluid" style={{ width: '200px' }} />
        </div>
        
        <div className="error-content animate__animated animate__fadeInUp" style={{ textAlign: "center", margin: "0 auto", justifyContent: "center" }}>
          <div className="error-code" >
            <div className="error-image" style={{ width: "100%", height: "100%" }}>
              <img src="/assets/404.png" alt="404" style={{ minWidth: '300px', height: "300px" }} className="" />
            </div>
          </div>
          
          <h2 className="error-title">Oops! Page Not Found</h2>
          <p className="error-message">
            The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          
          <Link to="/" className="home-button">
            <i className="fas fa-home"></i>
            <span>Back to Homepage</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 